<template>
  <v-dialog v-model="dialog" max-width="500" max-height="600" persistent>
    <v-card class="px-6 py-5">
      <v-row no-gutters>
        <v-col cols="12">
          <span class="title">Produto com EAN duplicado</span>
        </v-col>
        <v-col cols="12">
          <p class="texto-corrido subtitle mt-2 mb-0">
            Os produtos abaixo compartilham de um mesmo EAN, selecione o produto principal e os demais ficarão inativos.
          </p>
          <p class="texto-corrido subtitle mt-2 mb-0">
            EAN: <b>{{ ean }}</b>
          </p>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col cols="12">
          <v-text-field v-model="search" class="pt-3" outlined label="Buscar" append-icon="search" @input="updateFilteredItems"> </v-text-field>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col cols="12">
          <v-data-table :headers="headers" :items="pagedItems" hide-default-footer :items-per-page="items.length" :search="search" height="200px">
            <template v-slot:item.name="{ item }">
              <a v-if="item.showLink" target="_blank" :href="`#/produtos/alterar/${item.id}`">{{ item.name }}</a>
              <span v-else>{{ item.name }}</span>
            </template>
            <template v-slot:item.activeValue="{ item }">
              <v-radio-group v-model="item.activeValue" @change="handleActiveChange(item)">
                <v-radio :value="true" color="marca-0-l40" />
              </v-radio-group>
            </template>
            <template v-slot:item.active="{ item }">
              <mf-icon fill small :color="statusColor(item.active)">fiber_manual_record</mf-icon>
              <span>{{ item.active ? 'Ativo' : 'Inativo' }}</span>
            </template>
            <template v-slot:item.legacySku="{ item }">
              <span>{{ item.legacySku ? item.legacySku : '-' }}</span>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
      <v-row no-gutters class="mt-3" justify="end">
        <v-col cols="auto">
          <mf-button class="mr-4" text label="Cancelar" @click="cancelAction" />
        </v-col>
        <v-col cols="auto">
          <mf-button label="Selecionar" @click="actionButton" />
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array,
    },
    ean: {
      type: String,
    },
  },
  data() {
    return {
      itemSelected: {},
      search: '',
      itemsPerPage: 100,
      currentPage: 1,
    }
  },
  computed: {
    filteredItems() {
      return this.items.filter((item) => Object.values(item).some((val) => typeof val === 'string' && val.toLowerCase().includes(this.search.toLowerCase())))
    },
    pagedItems() {
      const startIndex = (this.currentPage - 1) * this.itemsPerPage
      return this.filteredItems.slice(startIndex, startIndex + this.itemsPerPage)
    },
    headers() {
      let headers = [
        { text: 'Ativo', value: 'activeValue', sortable: false },
        { text: 'Nome', value: 'name' },
        { text: 'SKU', value: 'legacySku', sortable: false },
        { text: 'Status', value: 'active', sortable: false, width: '20%' },
      ]

      if (!this.$getLoggedUser().has_club && this.$getIsEcommerce()) {
        headers = headers.filter((i) => i.value !== 'legacySku')
      }

      return headers
    },
  },
  mounted() {
    this.items.forEach((item) => {
      if (item.activeValue) this.itemSelected = item
    })
  },
  methods: {
    statusColor(status) {
      return status ? '#03e36a' : '#F15435'
    },
    cancelAction() {
      this.$emit('cancel')
    },
    actionButton() {
      this.$emit('action', { id: this.itemSelected.id })
    },
    handleActiveChange(item) {
      this.items.forEach((element) => {
        if (element.id !== item.id && element.activeValue && item.activeValue) {
          this.itemSelected = item
          element.activeValue = false
        }
      })
    },
    updateFilteredItems() {
      this.currentPage = 1
    },
  },
}
</script>

<style lang="scss" scoped>
.title {
  color: $cinza-d10;
  font-size: 22px;
  font-weight: 700;
  line-height: 120%;
  letter-spacing: 0.22px;
}
.subtitle {
  word-break: normal;
  font-size: 16px;
}
</style>
